// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"ade4fb55","436":"33fac2f9","453":"f394a27d","501":"1330ef7e","606":"d543b319","821":"dae33c55","925":"a2e847a2","969":"eb4abe40"}[chunkId] + ".chunk.js";
};